import React from 'react';
import classNames from 'classnames';
import { Paragraph } from '@uncinc/react-drupal-core';
import { List } from 'immutable';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import { PageHeader, Breadcrumbs, WysiwygField } from '../../../../components';

import './style.scss';

const TaxonomyTermPillarFull = (props) => {
  const { entity, className } = props;
  const classes = classNames(className, 'Pillar', 'TaxonomyTerm', 'TaxonomyTermPillarFull');

  const tid = entity.getIn(['tid', 0, 'value']);
  const image = entity.getIn(['field_thumbnail', 0, 'styles', 'large'], '');
  const title = entity.getIn(['name', 0, 'value'], '');
  const body = entity.getIn(['description', 0, 'processed'], '');

  const filters = {
    field_pillar_target_id: [tid],
  };

  return (
    <article typeof="schema:WebPage" className={classes}>
      <PageHeader>
        <Breadcrumbs includeCurrent />
        <div className="TaxonomyTermPillarFull__contentWrapper">
          <h1 className="PageHeader__title">{title}<div className="icon icon-asterisk icon-variant-2" /></h1>
          <WysiwygField
            property="schema:text"
            className="body-intro"
            html={body}
          />
        </div>
        <div className="TaxonomyTermPillarFull__imageWrapper">
          <Image
            alt="Image 1"
            lazyload={false}
            src={image}
          />
        </div>
      </PageHeader>

      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.getIn(['entity', 'id', 0, 'value']);
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={paragraph.get('entity')}
                filters={filters}
              />
            );
          })}
        </div>
      ) : null}
    </article>
  );
};

export default TaxonomyTermPillarFull;
